import { RemoteTable } from '@neo/blocks/data-table/data-table'
import type { ExtractedTableData } from '@neo/blocks/data-table/types'
import { ScrollAreaHorizontal } from '@neo/primitives/scroll-area'
import { useMemo } from 'react'
import type { REndpoint, RListEndpoints } from 'v2/api-console/voice/endpoints/types'
import { settingsService } from 'v2/shared/services/settings-service'
import { getAPIConsoleQueryKeys } from 'v2/shared/utils/query-key-management'
import { linkedEndpointsColumns } from './linked-endpoints-table.config'

interface LinkedEndpointsTableProps {
  applicationId: number
}

const extractTableData = (data: RListEndpoints): ExtractedTableData<REndpoint> => ({
  data: data.objects,
  totalCount: data.meta.total_count,
  hasNext: !!data.meta.next,
  hasPrevious: !!data.meta.previous,
})

export const LinkedEndpointsTable = ({ applicationId }: LinkedEndpointsTableProps) => {
  const fetchEndpoints = useMemo(
    () => async (params: Record<string, string>) => {
      const response = await settingsService.listEndpoints({
        ...params,
        application_id: applicationId.toString(),
        limit: '5',
      })
      return {
        ...response,
        data: response.data as RListEndpoints,
      }
    },
    [applicationId],
  )

  return (
    <div className="mt-4 space-y-1">
      <div className="flex items-center justify-between">
        <h3 className="text-p-500">Linked Endpoints</h3>
      </div>
      <div className="border rounded-lg overflow-hidden [&_thead]:bg-bg2 [&_thead_th]:bg-bg2 [&_thead_th:hover]:bg-bg2 [&_thead_th]:border-b-0 [&_div.flex.w-full.items-start]:hidden [&_div.flex.w-full.items-start]:!pb-0 [&_div.flex.w-full.items-start]:!mb-0 [&_table]:border-0 [&_tbody_tr]:border-0 [&_tbody_td[colspan]]:!text-center [&_tbody_td[colspan]]:w-full [&_.rounded-md.min-h-0.flex-1[data-radix-scroll-area-viewport]]:overflow-visible">
        <ScrollAreaHorizontal className="-mt-1">
          <div className="w-full min-w-[600px]">
            <RemoteTable
              idKey="endpoint_id"
              enableOffsetMode={true}
              ignoreUrlPagination={true}
              showLoader={true}
              defaultPageSize={5}
              queryKey={[
                ...getAPIConsoleQueryKeys().xmlApplications,
                'endpoints',
                String(applicationId),
              ]}
              columns={linkedEndpointsColumns}
              fetchService={fetchEndpoints}
              extractData={extractTableData}
            />
          </div>
        </ScrollAreaHorizontal>
      </div>
    </div>
  )
}
